"use strict";

(() => {
	const mobileBreakpoint = window.matchMedia("(max-width: 990px)");

	const getSections = (root = document) => {
		const sections = [];

		if (
			root instanceof Element &&
			root.matches(".multicolumn-section")
		) {
			sections.push(root);
		}

		if (root.querySelectorAll) {
			root
				.querySelectorAll(".multicolumn-section")
				.forEach((section) => sections.push(section));
		}

		return [...new Set(sections)];
	};

	const initSection = (section) => {
		const sliderElement = section.querySelector(".swiper--multicolumn");

		if (
			!sliderElement ||
			sliderElement.swiper ||
			typeof window.Swiper === "undefined"
		) {
			return;
		}

		sliderElement
			.querySelectorAll(".multicolumn-list__item")
			.forEach((slide) => {
				slide.classList.add("swiper-slide");
			});

		const nextButton = section.querySelector(".swiper-button-next");
		const previousButton = section.querySelector(".swiper-button-prev");

		new window.Swiper(sliderElement, {
			loop: false,
			watchOverflow: true,
			navigation:
				nextButton && previousButton
					? {
							nextEl: nextButton,
							prevEl: previousButton,
					  }
					: false,
		});
	};

	const destroySection = (section) => {
		const sliderElement = section.querySelector(".swiper--multicolumn");

		if (!sliderElement) {
			return;
		}

		if (sliderElement.swiper && !sliderElement.swiper.destroyed) {
			sliderElement.swiper.destroy(true, true);
		}

		sliderElement
			.querySelectorAll(".multicolumn-list__item")
			.forEach((slide) => {
				slide.removeAttribute("style");
				slide.classList.remove("swiper-slide");
			});
	};

	const updateSections = (root = document) => {
		getSections(root).forEach((section) => {
			if (mobileBreakpoint.matches) {
				initSection(section);
			} else {
				destroySection(section);
			}
		});
	};

	const handleBreakpointChange = () => {
		updateSections(document);
	};

	updateSections(document);

	if (mobileBreakpoint.addEventListener) {
		mobileBreakpoint.addEventListener("change", handleBreakpointChange);
	} else {
		mobileBreakpoint.addListener(handleBreakpointChange);
	}

	document.addEventListener("shopify:section:load", (event) => {
		updateSections(event.target);
	});

	document.addEventListener("shopify:section:unload", (event) => {
		getSections(event.target).forEach(destroySection);
	});
})();

// (function () {
// 	let swiperMulticolumn;
// 	const multicolumnSwipeEnabled = document.querySelector(
// 		".swiper--multicolumn",
// 	);

// 	const addClasses = () => {
// 		const slides = document.querySelectorAll(".multicolumn-list__item");
// 		slides.forEach((slide) => {
// 			slide.classList.add("swiper-slide");
// 		});
// 	};

// 	const initSlider = () => {
// 		swiperMulticolumn = new Swiper(".swiper--multicolumn", {
// 			loop: false,
		
// 			navigation: {
// 				nextEl: `.swiper-button-next`,
// 				prevEl: `.swiper-button-prev`,
// 			},
// 		});
// 	};

// 	const destroySlider = () => {
// 		const slides = document.querySelectorAll(".multicolumn-list__item");

// 		if (Array.isArray(swiperMulticolumn)) {
// 			swiperMulticolumn.forEach((swiper) => {
// 				swiper.destroy(true, true);
// 			});
// 		} else {
// 			swiperMulticolumn.destroy(true, true);
// 		}
// 		swiperMulticolumn = null;

// 		slides.forEach((slide) => {
// 			slide.removeAttribute("style");
// 			slide.classList.remove("swiper-slide");
// 		});
// 	};

// 	const initMulticolumn = () => {
// 		const multicolumnSection = document.querySelector(".multicolumn-section");

// 		const sectionResizeObserver = new ResizeObserver((entries) => {
// 			const [entry] = entries;

// 			if (entry.contentRect.width < 991 && multicolumnSwipeEnabled) {
// 				addClasses();
// 				initSlider();
// 			} else if (swiperMulticolumn) {
// 				destroySlider();
// 			}
// 		});

// 		sectionResizeObserver.observe(multicolumnSection);
// 	};

// 	if (swiperMulticolumn) {
// 		destroySlider();
// 	}
// 	addClasses();
// 	initMulticolumn();
// 	initSlider();
// 	document.addEventListener("shopify:section:load", function () {
// 		if (swiperMulticolumn) {
// 			destroySlider();
// 		}
// 		addClasses();
// 		initMulticolumn();
// 		initSlider();
// 	});
// })();
